import { Paperclip } from 'lucide-react';
import { useTranslation } from '@/shared/i18n/use-translation';

type AttachmentCountProps = {
  readonly count: number;
};

export function AttachmentCount({ count }: AttachmentCountProps) {
  const { tn } = useTranslation();
  if (!count) return null;
  return (
    <span
      className="inline-flex items-center gap-0.5 text-xs text-muted-foreground"
      title={tn(count, '{count} file', '{count} files')}
    >
      <Paperclip className="size-3" />
      {count}
    </span>
  );
}
